module.exports = __webpack_public_path__ + "2ed431335e7d3cb1c366ec6ae00d9068.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/763.png
// module id = 1693
// module chunks = 2